/**
 * Labstep
 *
 * @module components/UserGroupNotification/Mode
 * @desc Order Request status + option to change
 */

import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { Icon } from 'labstep-web/core/Icon';
import {
  UserGroupNotification,
  UserGroupNotificationMode,
  UserGroupNotificationModeValues,
} from 'labstep-web/models/user-group-notification.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { IUserGroupNotificationActionUpdateModeProps } from './types';

export const UserGroupNotificationActionUpdateMode: React.FC<
  IUserGroupNotificationActionUpdateModeProps
> = ({ userGroupNotification }) => (
  <EntityUpdateContainer
    entityName={UserGroupNotification.entityName}
    id={userGroupNotification.id}
    optimistic
  >
    {({ update }) => (
      <Dropdown.Dropdown
        trigger={
          <span className={styles.trigger}>
            {
              UserGroupNotificationModeValues[
                userGroupNotification.mode
              ]
            }
            <Icon name="chevron down" />
          </span>
        }
        icon={null}
      >
        <Dropdown.Menu>
          {Object.keys(UserGroupNotificationMode).map((key) => (
            <Dropdown.Item
              key={key}
              onClick={() => {
                update({ mode: key as UserGroupNotificationMode });
              }}
            >
              {
                UserGroupNotificationModeValues[
                  key as keyof typeof UserGroupNotificationModeValues
                ]
              }{' '}
              {userGroupNotification &&
                userGroupNotification.mode === key && (
                  <Icon name="check" />
                )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Dropdown>
    )}
  </EntityUpdateContainer>
);
